import { useAuthStore } from '../../store';
import { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import toast from "react-hot-toast";

export const handleTokenRefresh = async (
  error: AxiosError,
  axiosInstance: AxiosInstance,
  timeout: number
): Promise<any> => {
  const {
    loadAuthStateFromStorage,
    callRefreshToken,
    updateAuthStateInStorage,
    logout,
  } = useAuthStore.getState();

  const originalRequest = error.config as AxiosRequestConfig & {
    _retry?: boolean;
  };

  if (error.code === 'ECONNABORTED') {
    toast.error(`Request timed out after ${timeout/1000} seconds`);
  }

  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    try {
      const authState = loadAuthStateFromStorage();
      const { refreshToken } = authState || {};

      if (!refreshToken) throw new Error('No refresh token available');

      const response = await callRefreshToken(refreshToken);
      updateAuthStateInStorage(response.value);
      const { accessToken } = response.value;

      // Set new token for future requests
      axiosInstance.defaults.headers.common['Authorization'] =
        `Bearer ${accessToken}`;
      originalRequest.headers = {
        ...originalRequest.headers,
        Authorization: `Bearer ${accessToken}`,
      };

      return axiosInstance(originalRequest);
    } catch (refreshError: any) {
      if (
        refreshError.response?.status === 401 ||
        refreshError.message === 'No refresh token available'
      ) {
        logout();
      }
      return Promise.reject(refreshError);
    }
  }

  if(error.response?.status === 500){
    window.location.href = '/internal-server-error';
  }

  return Promise.reject(error);
};
